import {
  Row,
  Col,
  Card,
  Modal,
  Button,
  Dropdown,
  Container,
} from "react-bootstrap";
import {
  APB,
  ACT_PLAN,
  POINT_ICON,
  ADLD_VIDEO,
  ACROSS_LOGO,
  UPLOAD_VIDEO_BAR,
  UPLOAD_INSTRUCTION_VIDEO,
} from "../../assets";
import axios from "axios";
import { toast } from "react-toastify";
import Form from "react-bootstrap/Form";
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate } from "react-router-dom";
import React, { useState, useRef } from "react";
import { useMediaQuery } from "react-responsive";
import InputGroup from "react-bootstrap/InputGroup";

import "./styles.css";
import { X_API_KEY } from "../../constants";
import { FcCamcorderPro } from "react-icons/fc";
import { getLanguage } from "../../utils/localization";
import LoadingSpinner from "../../components/GlobalLoading";

const UploadPolicy = () => {
  const navigate = useNavigate();

  const mediaStreamRef = useRef(null);
  const recordedChunksRef = useRef([]);
  const mediaRecorderRef = useRef(null);

  const isXs = useMediaQuery({ maxWidth: 575 }); // xs <576px
  const isMd = useMediaQuery({ minWidth: 768 });

  const [showError, setShowError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const [videoSrc, setVideoSrc] = useState(false);
  const [isRecording, setIsRecording] = useState(false);
  const [videoRecInBase64, setVideoRecInBase64] = useState("");
  const [apbModel, setApbModel] = useState("");
  const [loading, setLoading] = useState(false);
  const [apbBrands, setApbBrands] = useState("");
  const [bppsTaxId, setBppsTaxId] = useState("");
  const [bppsPlanId, setBppsPlanId] = useState("");
  const [bppsTaxIdList, setBppsTaxIdList] = useState([]);
  const [selectedValue, setSelectedValue] = useState("Select an option");
  const [videoPreviewStream, setVideoPreviewStream] = useState(null);

  const [isUserMobile, setIsUserMobile] = useState("");
  const [isUserName, setIsUserName] = useState("");
  const [isUserEmail, setIsUserEmail] = useState("");
  const [isUserImei, setIsUserImei] = useState("");

  const handleSelect = (eventKey) => {
    setSelectedValue(eventKey);
  };

  const searchTByMobileApi = (searchQuery) => {
    axios(
      `https://portal.acrossassist.com/api/partner/v1/apb/GetBppsTaxIdByMobileNumber?CustomerMobileNumber=${searchQuery}`,
      {
        method: "GET",
        headers: { "x-api-key": X_API_KEY, "Content-Type": "application/json" },
      }
    )
      .then((res) => {
        if (res?.data?.statusCode === 200) {
          setBppsTaxIdList(res?.data?.data);
        }
        if (res?.data?.statusCode === 400) {
          toast.error(res?.data?.msg);
        }
        if (res?.data?.statusCode === 404) {
          // toast.error(res?.data?.msg);
          setErrorMessage("*Customer's mobile number does not exist.");
          setShowError(true);
        }
      })
      .catch((e) => {});
  };

  const getBrandAndModelByBppsTaxIdApi = (refId) => {
    const DATA = { BBPSTaxRefId: refId };

    axios(
      "https://portal.acrossassist.com/api/partner/v1/apb/GetBrandAndModelByBppsTaxId",
      {
        method: "POST",
        data: DATA,
        headers: {
          "x-api-key": X_API_KEY,
        },
      }
    )
      .then((res) => {
        if (res?.data?.statusCode === 200) {
          setApbBrands(res?.data?.data?.brands);
          setApbModel(res?.data?.data?.model);
        }
        if (res?.data?.statusCode === 400) {
          toast.error(res?.data?.msg);
        }
        if (res?.data?.statusCode === 404) {
          toast.error(res?.data?.msg);
        }
      })
      .catch((e) => {});
  };

  const startRecording = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({
        video: { facingMode: "environment" },
      });

      mediaStreamRef.current = stream;

      setVideoPreviewStream(stream);

      mediaRecorderRef.current = new MediaRecorder(stream);

      mediaRecorderRef.current.ondataavailable = (event) => {
        if (event.data.size > 0) {
          recordedChunksRef.current.push(event.data);
        }
      };

      mediaRecorderRef.current.onstop = () => {
        const blob = new Blob(recordedChunksRef.current, { type: "video/mp4" });
        recordedChunksRef.current = [];

        const videoURL = URL.createObjectURL(blob);
        setVideoSrc(videoURL);

        convertToBase64(blob);
      };

      mediaRecorderRef.current.start();
      setIsRecording(true);
    } catch (error) {}
  };

  const stopRecording = () => {
    if (mediaRecorderRef.current) {
      mediaRecorderRef.current.stop();
    }

    if (mediaStreamRef.current) {
      mediaStreamRef.current.getTracks().forEach((track) => track.stop());
    }

    setVideoPreviewStream(null);

    setIsRecording(false);
  };

  const convertToBase64 = (blob) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      const base64String = reader.result.split(",")[1];
      setVideoRecInBase64(base64String);
    };
    reader.readAsDataURL(blob);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const imeiRegex = /^[0-9]+$/;
    const nameRegex = /^[a-zA-Z .]{2,}$/;

    if (!isUserMobile) {
      setErrorMessage(
        "*Please enter your mobile number to search for the BBPS Tax ID."
      );
      setShowError(true);
    } else if (isUserMobile?.length < 10) {
      setErrorMessage("*Mobile number must be 10 digits.");
      setShowError(true);
    } else if (!isUserName) {
      setErrorMessage("*Please enter your name.");
      setShowError(true);
    } else if (!nameRegex.test(isUserName)) {
      setErrorMessage("*Name must contain only letters, spaces, or periods.");
      setShowError(true);
    } else if (!isUserImei) {
      setErrorMessage("*Please enter the IMEI number.");
      setShowError(true);
    } else if (isUserImei.length < 15) {
      setErrorMessage("*The IMEI number must be 15 digits long.");
      setShowError(true);
    } else if (!imeiRegex.test(isUserImei)) {
      setErrorMessage("*The IMEI number must contain only digits.");
      setShowError(true);
    } else if (videoRecInBase64 === "") {
      // setErrorMessage("*Please record a video and upload it.");
      // setShowError(true);
    } else {
      uploadDetailsApi();
      setShowError(false);
    }
  };
  const handleClose = () => {
    setShowError(false);
  };

  const uploadDetailsApi = async (values) => {
    setLoading(true);
    const DATA = {
      Email: isUserEmail,
      BrandName: apbBrands,
      ModelName: apbModel,
      UserName: isUserName,
      MobileNumber: isUserMobile,
      DeviceImage: videoRecInBase64,
      imeiOne: isUserImei,
      PaymentRequestId: bppsTaxId,
    };

    axios(
      "https://portal.acrossassist.com/api/partner/v1/apb/SaveAirtelPaymentBankDetailsVideo",
      {
        method: "POST",
        data: DATA,
        headers: {
          "x-api-key": X_API_KEY,
          "Content-Type": "application/json",
        },
      }
    )
      .then((res) => {
        if (res?.data?.statusCode === 200) {
          setVideoRecInBase64("");
          const data = {
            createdDate: res?.data?.createddate,
            phoneNumber: res?.data?.mobilenumber,
          };
          navigate("/status", { state: data });
          setLoading(false);
        } else {
          toast.error("Please validate your form and Try again !");
          setLoading(false);
        }
        setLoading(false);
      })
      .catch((e) => {
        toast.error("Form not submitted. Please try again");
        setLoading(false);
      });
  };

  return (
    <Container
      fluid
      className="bg-light py-0 px-0"
      style={{ minHeight: "100vh" }}
    >
      <Card className="border-0">
        <Card.Body>
          <Row className="d-flex justify-content-between align-items-center px-0 mb-4">
            <Col xs={6} md={6} className="d-flex align-items-center">
              <img
                alt="Apb Logo"
                className="img-fluid me-3"
                src={APB}
                width={130}
              />
              <img
                alt="Across Logo"
                className="img-fluid"
                src={ACROSS_LOGO}
                width={130}
              />
            </Col>

            <Col
              xs={12}
              md={12}
              lg={6}
              className="d-flex justify-content-end align-items-center gap-0 flex-nowrap"
            >
              <button
                style={{ fontSize: "0.8rem", padding: isMd && "10px 15px" }}
                className="btn gradient-btn-border me-3"
                onClick={() => navigate("/checkstatus")}
              >
                {getLanguage("PLCY_UPLD.CHCKSTATS")}
              </button>

              <button
                style={{ fontSize: "0.8rem", padding: isMd && "10px 15px" }}
                className="btn gradient-btn-border me-3"
                onClick={() => navigate("/download-certificate")}
              >
                {getLanguage("PLCY_UPLD.DW_CRTFCT_BTN")}
              </button>

              <button
                style={{
                  fontSize: "0.8rem",
                  padding: isXs ? "15px" : isMd && "10px 15px",
                }}
                className="btn gradient-btn "
                onClick={() => navigate("/admin-signin")}
              >
                {getLanguage("PLCY_UPLD.ADMN_LGN")}
              </button>
            </Col>
          </Row>

          <Row className="mt-4">
            <Col xs={12} className="activate-plan-img">
              <img
                alt="Activate Plan"
                className="img-fluid"
                style={{ width: "100%", objectFit: "contain" }}
                src={ACT_PLAN}
              />
            </Col>
          </Row>

          <Form noValidate className="p-2" onSubmit={handleSubmit}>
            <p className="text-danger mt-5 text-left input-label-heading">
              {getLanguage("PLCY_UPLD.HDNG")}
            </p>

            <Row>
              <Col xs={12} md={6} className="mb-3 py-1 px-4">
                <Form.Group controlId="validationFormikUsername">
                  <Form.Label className="common-label">
                    {getLanguage("VW_CRTFCT.MBL")}
                  </Form.Label>
                  <InputGroup hasValidation>
                    <Form.Control
                      type="text"
                      maxLength={10}
                      name="isUserMobile"
                      value={isUserMobile}
                      className="common-input"
                      aria-describedby="inputGroupPrepend"
                      placeholder={getLanguage("PLCY_UPLD.SRCH_MBL")}
                      onChange={(e) => {
                        setIsUserMobile(e?.target?.value);
                        searchTByMobileApi(e?.target.value);
                      }}
                    />
                  </InputGroup>
                </Form.Group>
              </Col>

              <Col xs={12} md={6} className="mb-3 py-1 px-4">
                <Form.Group controlId="validationFormikDropdown">
                  <Form.Label className="common-label">
                    {getLanguage("PLCY_UPLD.BBPS_LBL")}
                  </Form.Label>
                  <InputGroup hasValidation>
                    <Dropdown
                      data-bs-theme="dark"
                      onSelect={(e) => handleSelect(e)}
                    >
                      <Dropdown.Toggle
                        variant=""
                        className="drop-down-input"
                        id="dropdown-button-dark-example1"
                      >
                        {selectedValue
                          ? selectedValue
                          : getLanguage("PLCY_UPLD.SLCT_OPTN")}
                      </Dropdown.Toggle>

                      <Dropdown.Menu className="drop-down-menu">
                        {bppsTaxIdList?.map((item) => (
                          <Dropdown.Item
                            onClick={() => {
                              getBrandAndModelByBppsTaxIdApi(
                                item?.bbpsTaxRefId
                              );
                              setBppsTaxId(item?.id);
                              setBppsPlanId(item?.planId);
                            }}
                            eventKey={item?.bbpsTaxRefId}
                          >
                            {item?.bbpsTaxRefId}
                          </Dropdown.Item>
                        ))}
                      </Dropdown.Menu>
                    </Dropdown>
                  </InputGroup>
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col xs={12} md={6} className="mb-3 py-1 px-4">
                <Form.Group controlId="validationFormikUsername">
                  <Form.Label className="common-label">
                    {getLanguage("PLCY_UPLD.NME_LBL")}
                  </Form.Label>
                  <InputGroup hasValidation>
                    <Form.Control
                      type="text"
                      name="name"
                      value={isUserName}
                      className="common-input"
                      aria-describedby="inputGroupPrepend"
                      placeholder={getLanguage("PLCY_UPLD.NME_PLCHLDR")}
                      onChange={(e) => setIsUserName(e?.target?.value)}
                    />
                  </InputGroup>
                </Form.Group>
              </Col>

              <Col xs={12} md={6} className="mb-3 py-1 px-4">
                <Form.Group controlId="formGridEmail">
                  <Form.Label className="common-label">
                    {getLanguage("PLCY_UPLD.EML_LBL")}
                  </Form.Label>
                  <InputGroup hasValidation>
                    <Form.Control
                      type="email"
                      name="email"
                      value={isUserEmail}
                      className="common-input"
                      placeholder={getLanguage("PLCY_UPLD.EML_PLCHLDR")}
                      onChange={(e) => setIsUserEmail(e?.target?.value)}
                    />
                  </InputGroup>
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col xs={12} md={6} className="mb-3 py-1 px-4">
                <Form.Group controlId="validationFormik02">
                  <Form.Label className="common-label">
                    {getLanguage("PLCY_UPLD.BRND_LBL")}
                  </Form.Label>
                  <Form.Control
                    readOnly
                    type="text"
                    name="brand"
                    value={apbBrands}
                    className="common-input"
                  />
                </Form.Group>
              </Col>

              <Col xs={12} md={6} className="mb-3 py-1 px-4">
                <Form.Group>
                  <Form.Label className="common-label">
                    {getLanguage("PLCY_UPLD.MDL_LBL")}
                  </Form.Label>
                  <Form.Control
                    readOnly
                    type="text"
                    name="model"
                    value={apbModel}
                    placeholder="Model"
                    className="common-input"
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col xs={12} md={6} className="mb-3 py-1 px-4">
                <Form.Group controlId="validationFormikUsername">
                  <Form.Label className="common-label">
                    {getLanguage("PLCY_UPLD.IMEI_LBL")}
                  </Form.Label>
                  <InputGroup hasValidation>
                    <Form.Control
                      type="text"
                      maxLength={15}
                      name="imeiNumber"
                      value={isUserImei}
                      className="common-input"
                      aria-describedby="inputGroupPrepend"
                      onChange={(e) => setIsUserImei(e?.target?.value)}
                      placeholder={getLanguage("PLCY_UPLD.IMEI_PLCHLDR")}
                    />
                  </InputGroup>
                </Form.Group>
              </Col>
            </Row>

            <div>
              <img
                className="img-fluid"
                alt="Responsive Example"
                src={UPLOAD_VIDEO_BAR}
              />
            </div>

            <div className="mt-3">
              <div className="instructions-container border-0 rounded p-1">
                <div className="instruction-item d-flex align-items-start">
                  <img
                    src={POINT_ICON}
                    alt="Points Icon"
                    className="intructions-point-icon"
                  />
                  <p>
                    {getLanguage("PLCY_UPLD.GUIDE_EN1")} <br />
                    <span className="text-muted">
                      {getLanguage("PLCY_UPLD.GUIDE_HN1")}
                    </span>
                  </p>
                </div>

                <div className="instruction-item d-flex align-items-start">
                  <img
                    src={POINT_ICON}
                    alt="Points Icon"
                    className="intructions-point-icon"
                  />
                  <p className="mb-1">
                    {getLanguage("PLCY_UPLD.GUIDE_EN2")} <br />
                    <span className="text-muted">
                      {getLanguage("PLCY_UPLD.GUIDE_HN2")}
                    </span>
                  </p>
                </div>

                <div className="instruction-item d-flex align-items-start">
                  <img
                    src={POINT_ICON}
                    alt="Points Icon"
                    className="intructions-point-icon"
                  />
                  <p className="mb-0">
                    {getLanguage("PLCY_UPLD.GUIDE_EN3")} <br />
                    <span className="text-muted">
                      {getLanguage("PLCY_UPLD.GUIDE_HN3")}
                    </span>
                  </p>
                </div>
              </div>
            </div>

            <div className="container-fluid mt-3 d-flex flex-column align-items-center text-center video-main-container">
              <div className="container-fluid text-center video-sub-main-container">
                <div className="row g-4 align-items-center">
                  <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                    <div className="mt-2">
                      <p className="text-primary fw-bold font-size-vw">
                        {getLanguage("PLCY_UPLD.HW2UPLD")}
                      </p>
                    </div>

                    {bppsPlanId === 3231 ? (
                      <video
                        loop
                        muted
                        autoPlay
                        src={ADLD_VIDEO}
                        className="upload-guide-video"
                        onContextMenu={(e) => e.preventDefault()}
                      />
                    ) : (
                      <video
                        loop
                        muted
                        autoPlay
                        src={UPLOAD_INSTRUCTION_VIDEO}
                        className="upload-guide-video"
                        onContextMenu={(e) => e.preventDefault()}
                      />
                    )}
                  </div>

                  <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                    <div className="mt-4">
                      <p className="text-primary fw-bold font-size-vw">
                        {getLanguage("PLCY_UPLD.UPLD_PRV_VDO")}
                      </p>
                    </div>

                    <div className="row">
                      <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                        {isRecording ? (
                          <video
                            className="upload-guide-video"
                            ref={(videoElement) => {
                              if (videoElement) {
                                videoElement.srcObject = videoPreviewStream;
                                videoElement.play();
                              }
                            }}
                          />
                        ) : videoRecInBase64 ? (
                          <video
                            controls
                            className="upload-guide-video"
                            src={`data:video/mp4;base64,${videoRecInBase64}`}
                          />
                        ) : (
                          <div className="card d-flex justify-content-center align-items-center upload-card-container">
                            <div>
                              <FcCamcorderPro size={30} />
                            </div>
                            <h5 className="text-secondary mt-1">
                              {getLanguage("PLCY_UPLD.RCRD_UPLD_VDO")}
                            </h5>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="container-fluid d-flex justify-content-end mt-1 mb-3">
                {videoRecInBase64 ? (
                  <button
                    className="btn responsive-btn"
                    onClick={isRecording ? stopRecording : startRecording}
                  >
                    {getLanguage("PLCY_UPLD.AGN_RCRD_VDO")}
                  </button>
                ) : (
                  <button
                    className="btn responsive-btn"
                    onClick={isRecording ? stopRecording : startRecording}
                  >
                    {isRecording ? "Stop Video Recording" : "Record Video"}
                  </button>
                )}
                <style jsx>{`
                  .responsive-btn {
                    background: linear-gradient(
                      90deg,
                      #98d5fa,
                      #1e6cfd,
                      #98d5fa
                    );
                    border: none;
                    color: white;
                    padding: 10px;
                    font-size: 16px;
                    cursor: pointer;
                    font-weight: bold;
                    border-radius: 5px;
                    font-family: "Poppins", serif;
                    transition: transform 0.2s, opacity 0.2s;
                    width: 46%; /* Default for lg and md screens */
                  }

                  @media (max-width: 991.98px) {
                    /* For sm and xs screens */
                    .responsive-btn {
                      width: 100%;
                    }
                  }
                `}</style>
              </div>
            </div>

            <div className="container-fluid d-flex justify-content-center w-100 mt-5">
              <Button type="submit" className="btn responsive-btn">
                {getLanguage("PLCY_UPLD.SBMT")}
              </Button>

              <style jsx>{`
                .responsive-btn {
                  background: linear-gradient(90deg, #98d5fa, #1e6cfd, #98d5fa);
                  border: none;
                  color: white;
                  padding: 10px;
                  font-size: 16px;
                  cursor: pointer;
                  font-weight: bold;
                  border-radius: 5px;
                  font-family: "Poppins", serif;
                  transition: transform 0.2s, opacity 0.2s;
                  width: 50%; /* Default for lg and md screens */
                }

                @media (max-width: 991.98px) {
                  /* For sm and xs screens */
                  .responsive-btn {
                    width: 100%;
                  }
                }
              `}</style>
            </div>
          </Form>

          <Modal
            centered
            show={showError}
            onHide={handleClose}
            dialogClassName="custom-modal p-4"
          >
            <Modal.Header className="border-0" closeButton>
              <Modal.Title style={{ fontFamily: '"Poppins",serif' }}>
                {getLanguage("MDL.WARN")}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="error-icon-container">
                <img
                  src={require("../../assets/gif/Warning.gif")}
                  alt="Error"
                  className="error-gif"
                  width="50"
                  height="50"
                />
              </div>
              <div style={{ color: "red", fontFamily: '"Poppins",serif' }}>
                {errorMessage}
              </div>
            </Modal.Body>
            <Modal.Footer className="justify-content-center border-0">
              <Button
                className="p-2 w-50"
                variant="primary"
                onClick={handleClose}
                style={{ fontFamily: '"Poppins",serif' }}
              >
                {getLanguage("MDL.CLSE")}
              </Button>
            </Modal.Footer>
          </Modal>
        </Card.Body>
      </Card>

      <LoadingSpinner open={loading} />
    </Container>
  );
};

export default UploadPolicy;
